import { Divider } from 'primereact/divider';
import React from 'react';

/**
 * @param {import('primereact/divider').DividerProps} props
 */
export const LineDivider = (props) => {
    return <Divider className='divider--line' {...props} />;
};
